import { Box, Button, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import Dropzone from 'react-dropzone'
import { toast } from 'react-toastify';

var MAX_HEIGHT = 300;

class ImageUpload extends Component {
    state = {
        file: '',
        imagePreviewUrl: '',
        data_uri: null,
        files: []
    }

    onDrop = (files) => {
        this.setState({files});
    };

    handleSubmitDocument = async (e) => {
        e.preventDefault();
        console.log("[INFO], handleSubmitDocument , submit document ,",this.state.files)

        const dataFile = new FormData() 
        dataFile.append('file', this.state.files[0],this.state.files[0].name)
        
        var newfile = dataFile.get('file');
        console.log(newfile.name);       //filename
        console.log(newfile.size);       //filesize

        try {

            const response = await fetch('/download/multiple/document', {
                method: 'POST',
                headers: {
                    //'Content-Type': 'multipart/form-data',
                    //'X-Requested-With': 'XMLHttpRequest',
                    boxAssoId: this.props.boxAssoId,
                    // paygoid: this.props.boxId,
                },
                body: dataFile,
                credentials: 'same-origin'
            });
            console.log("[INFO], resquest has been sent");
            const resp = await response.json();
            console.log(resp);
            if (resp.msg != "OK") {
                console.log("[SUCESS], handleSubmitDocument response ", resp)
                toast.error("ERROR"+resp.msg)
                return;
            }
            toast.info("Opération enregistrée avec succès")
            this.setState({files: []});
        } catch (err) {
            console.log("[ERROR], handleSubmitDocument data", err)
            toast.error("ERROR"+err)
        }
    }

    render() {
        // let {imagePreviewUrl} = this.state;
        // let $imagePreview = null;
        // if (imagePreviewUrl) {
        //     $imagePreview = (<img src={imagePreviewUrl} width={300}/>);
        // } else {
        //     $imagePreview = (
        //         <div className="previewText">Choissisez une image</div>
        //     );
        // }

        const files = this.state.files.map((file, i) => (
            <li key={`${file.name}-${i}`}>
                {file.name} - {file.size} bytes
            </li>
        ));


        return (
            <Box>
            {/* <div className="card-body card-padding"> */}
                <Dropzone onDrop={this.onDrop}>
                    {({getRootProps, getInputProps}) => (
                        <section className="container" >
                            <div 
                                {...getRootProps({className: 'dropzone'})} 
                                style={{"borderStyle": "dashed", "borderRadius": "10px", "borderColor": "#aaa", "textAlign": "center", "fontSize": "20px"} }
                            >
                                <input {...getInputProps()} />
                                <Box p={2}>
                                    <Typography variant="h6">Deposer vos images et fichiers</Typography>
                                </Box>
                            </div>
                            <aside>
                                <h4>Files</h4>
                                <ul>{files}</ul>
                            </aside>
                        </section>
                    )}
                </Dropzone>
                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleSubmitDocument}
                        type="submit"
                    >
                        Upload Document
                    </Button>
                    {/* <button
                    className="btn bgm-amber waves-effect "
                    type="submit"
                    onClick={(e) => this.handleSubmitDocument(e)}>Upload Document</button> */}
                </Box>
            </Box>
        )
    }
}

export default ImageUpload